import { useEffect, useRef, useState } from 'react';

const TICK_MS = 1000;

/**
 * Frontend-only stopwatch for the sync checklist's current row. The SSE contract has no per-step
 * timestamp — `SyncStatusResponse.startedAt` covers the whole sync — so elapsed time is measured
 * locally from the moment this hook first observes each `key` value, and restarts at 0 whenever it
 * changes. Ticks once a second for as long as the component using it stays mounted.
 */
export function useElapsedSeconds(key: string | null): number {
    const startRef = useRef(Date.now());
    const [elapsedSeconds, setElapsedSeconds] = useState(0);

    useEffect(() => {
        startRef.current = Date.now();
        setElapsedSeconds(0);
    }, [key]);

    useEffect(() => {
        const id = setInterval(() => {
            setElapsedSeconds(Math.floor((Date.now() - startRef.current) / 1000));
        }, TICK_MS);
        return () => clearInterval(id);
    }, [key]);

    return elapsedSeconds;
}
